import { render, staticRenderFns } from "./DailyThermalCpuBurnInFailRateSummary.vue?vue&type=template&id=b42ab4da"
import script from "./DailyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"
export * from "./DailyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports